"use client";

import { create } from "zustand";

/**
 * Global state for cart drawer UI (open/closed state only)
 * Cart data itself comes from the TanStack Query cache via useBarstaffCart
 */
interface CartDrawerStore {
  isOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
  toggleCart: () => void;
}

export const useCartDrawer = create<CartDrawerStore>((set) => ({
  isOpen: false,
  openCart: () => {
    console.log("🛒 [CartDrawer] Opening cart");
    set({ isOpen: true });
  },
  closeCart: () => {
    console.log("🛒 [CartDrawer] Closing cart");
    set({ isOpen: false });
  },
  toggleCart: () => {
    set((state) => {
      console.log(`🛒 [CartDrawer] Toggling cart: ${!state.isOpen}`);
      return { isOpen: !state.isOpen };
    });
  },
}));
